var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJitsiLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "39.68 26.45 657.35 983.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "j",
    x1: 439.904,
    x2: 469.717,
    y1: 455.739,
    y2: 557.748,
    gradientTransform: "translate(-297.23 320.86)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0f3060",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    style: {
      stopColor: "#0575ce",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    style: {
      stopColor: "#0575ce",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0f3060",
      stopOpacity: 1
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "k",
    x1: 382.802,
    x2: 347.443,
    y1: 585.226,
    y2: 645.024,
    gradientTransform: "translate(-297.23 320.86)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092d61",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0575ce",
      stopOpacity: 1
    }
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "l",
    x1: 415.814,
    x2: 436.356,
    y1: 620.098,
    y2: 486.431,
    gradientTransform: "translate(-297.23 320.86)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0f3060",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    style: {
      stopColor: "#0575ce",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#0575ce",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0f3060",
      stopOpacity: 1
    }
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#d",
    id: "m",
    x1: 389.593,
    x2: 308.986,
    y1: 763.302,
    y2: 420.016,
    gradientTransform: "translate(34.352 723.04)scale(.24573)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    style: {
      stopColor: "#fff4e1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#fff4e1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8400",
      stopOpacity: 1
    }
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#e",
    id: "n",
    x1: 528.82,
    x2: 458.469,
    y1: 511.718,
    y2: 527.107,
    gradientTransform: "translate(-297.23 320.86)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#f",
    id: "o",
    x1: 197.178,
    x2: 146.542,
    y1: 703.802,
    y2: 785.904,
    gradientTransform: "translate(34.352 723.04)scale(.24573)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffc768",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378,
    style: {
      stopColor: "#ff8400",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    style: {
      stopColor: "#ff8400",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc768",
      stopOpacity: 1
    }
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#e",
    id: "p",
    x1: 413.632,
    x2: 423.525,
    y1: 484.601,
    y2: 541.833,
    gradientTransform: "matrix(1.0334 0 0 1.01383 -309.91 314.183)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#g",
    id: "q",
    x1: 409.696,
    x2: 467.886,
    y1: 559.364,
    y2: 676.035,
    gradientTransform: "translate(34.352 723.04)scale(.24573)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341,
    style: {
      stopColor: "#ffc768",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    style: {
      stopColor: "#ffc768",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8400",
      stopOpacity: 1
    }
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#h",
    id: "r",
    x1: 522.636,
    x2: 585.933,
    y1: 168.687,
    y2: 161.109,
    gradientTransform: "translate(34.352 723.04)scale(.24573)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#fff4e1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#fff4e1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff8400",
      stopOpacity: 1
    }
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#g",
    id: "s",
    x1: 481.49,
    x2: 405.411,
    y1: 417.5,
    y2: 316.79,
    gradientTransform: "translate(34.352 723.04)scale(.24573)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#e",
    id: "t",
    x1: 473.092,
    x2: 457.69,
    y1: 499.584,
    y2: 477.6,
    gradientTransform: "translate(-297.23 320.86)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#e",
    id: "u",
    x1: 394.341,
    x2: 446.313,
    y1: 501.802,
    y2: 485.378,
    gradientTransform: "translate(-297.23 320.86)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#e",
    id: "v",
    x1: 395.813,
    x2: 369.553,
    y1: 590.733,
    y2: 572.169,
    gradientTransform: "translate(-297.23 320.86)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#i",
    id: "w",
    x1: 297.053,
    x2: 310.455,
    y1: 667.162,
    y2: 713.866,
    gradientTransform: "translate(34.352 723.04)scale(.24573)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#212a3a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404e67",
      stopOpacity: 0
    }
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#i",
    id: "x",
    x1: 246.304,
    x2: 366.879,
    y1: 690.027,
    y2: 632.16,
    gradientTransform: "matrix(.09308 0 0 .18605 131.942 665.872)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#i",
    id: "y",
    x1: 301.052,
    x2: 367.946,
    y1: 645.899,
    y2: 654.721,
    gradientTransform: "matrix(-.09281 -.00704 .01407 -.18552 186.2 929.708)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#i",
    id: "z",
    x1: 279.817,
    x2: 386.786,
    y1: 688.324,
    y2: 667.635,
    gradientTransform: "translate(98.31 642.637)scale(.24573)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#i",
    id: "A",
    x1: 338.144,
    x2: 266.215,
    y1: 668.301,
    y2: 702.893,
    gradientTransform: "translate(25.55 660.77)scale(.24573)",
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M52.514 963.96c-.598-1.315-1.087-2.498-1.087-2.63 0-.133-2.08-11.075-2.317-13.887-1.035-12.277-2.668-13.453-2.212-24.399.276-6.63-.644-8.892 1.313-14.315 4.031-11.167 6.987-15.56 12.225-18.174 4.25-2.12 8.237-1.832 11.98.865.986.711 4.295 2.95 7.354 4.977 3.058 2.026 6.691 4.483 8.072 5.46 1.381.976 3.685 2.384 5.12 3.13 2.53 1.315 2.624 1.335 3.137.67 1.128-1.458 3.85-5.553 5.321-7.508 7.373-9.79.43-8.702-1.305-9.213-2.728-.803-3.877-1.98-6.427-4.967-5.922-6.94-8.728-14.662-9.143-24.204-.481-11.08.633-20.015 5.498-25.1 2.086-2.18 6.5-5.346 10.535-7.556 3.418-1.87 24.38-5.782 26.219-4.97.919.407-3.638-11.638-1.016-27.298.521-3.111 4.06-12.738 4.434-13.393.923-1.618 16.135-6.824 20.462-9.365 4.835-2.84 15.29-9.68 16.078-14.766 1.731-11.179 2.038-15.956 2.76-16.375 1.074-.625 8.252 14.175 3.393 28.13-.958 2.755-5.532 9.15-7.58 11.824-1.474 1.926 1.728 2.826 3.57 5.607 1.676 2.529 2.777 8.71 2.992 11.914.22 3.271-.815 9.982-1.742 11.299-.376.533-.53 1.057-.344 1.171.184.114 1.434-.035 2.777-.33s4.254-.767 6.468-1.047c3.943-.497 4.084-.49 6.76.333 4.014 1.234 23.538 5.951 11.08 60.507-4.128 18.075-23.39 41.925-25.811 40.078l-5.964-4.547-6.873 10.19c-3.508 3.603-7.291 7.08-9.522 8.753-3.52 2.64-10.565 6.798-11.516 6.798-.245 0-1.632.57-3.083 1.265-4.195 2.012-10.479 3.661-17.135 4.098-25.771 1.67-15.94-1.442-37.278-11.775-1.683-.815-5.558 3.297-10.227 7.546-4.986 4.536-7.603 7.988-9.58 12.638a626 626 0 0 1-2.316 5.365c-1.645 3.748-2.998 8.933-3.199 12.258-.098 1.627-.315 3.042-.481 3.145-.167.103-.793-.888-1.39-2.202m28.332-45.91c3.303-.835 3.665-1.019 7.217-3.677 2.546-1.905 4.124-5.345 4.8-5.646 4.433-1.966-3.307-3.736-6.201-5.688s-6.658-3.395-9.221-5.353c-2.564-1.956-4.784-3.482-4.933-3.39s-.275 1.405-.279 2.918c-.01 4.414-.602 8.842-1.429 10.695-.421.943-.846 2.76-.945 4.04-.228 2.962.462 4.386 2.913 6.02 2.066 1.377 2.924 1.385 8.078.082m119.706-83.584c-1.076-7.225-.185-17.16-5.815-20.777-12.988-8.345-14.413-.07-15.21 1.759-1.31 3.008-2.118 5.469-1.123 8.776 3.057 10.16 6.967 19.158 8.823 26.38 2.13 8.289 4.478 13.53 4.713 20.03.166 4.614.123 5.099-.556 6.165-.966 1.515-15.553 5.227-22.898 7.391-2.522.743-.288 6.122-.577 7.893s-4.237 11.667-2.967 13.657c12.529 19.633 40.235-40.207 35.61-71.274m-26.989 48.272c1.96-.471 3.792-1.046 4.072-1.278s.99-.384 1.58-.34c1.054.08 5.182-1.219 5.5-1.73.089-.145 3.772-2.066 3.035-2.554s-15.132-11.07-17.196-12.147c-23.77-12.393-36.266-13.246-44.114-11.665-13.445 2.709-25.057 9.526-26.454 11.207-.422.508 21.05-6.66 36.29.871 2.816 1.392 8.63 3.783 13 8.463 3.993 4.275 7.634 8.798 10.5 9.562 3.106.828 9.472.648 13.787-.39m-28.657-51.097c7.526-1.317 19.186-16.952 18.279-18.416-.123-.198 2.255-4.145 1.869-4.222-14.084-2.808-13.745-16.832-13.948-16.957s-20.765 9.71-25.504 11.758c-4.02 1.739.575 12.103 3 18.535 1.078 2.862 7.017 6.678 9.407 8.234 2.828 1.84 6.254 1.18 6.897 1.068m16.22-47.717c4.064-3.203 14.888-19.234 13.74-25.74-4.68-26.505-6.696-10.096-6.997-7.731-.124.98-.478 3.15-.787 4.822a138 138 0 0 0-.875 5.365c-.172 1.279-.648 3.532-1.058 5.008a268 268 0 0 0-1.439 5.45c-.381 1.523-1.665 5.273-2.852 8.334-1.188 3.061-2.16 5.638-2.16 5.728 0 .447.825.027 2.428-1.236",
    style: {
      fill: "url(#j)",
      fillOpacity: 1
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.58 963.12c6.352-26.32 12.1-29.27 27.227-39.026-3.328-1.891-11.518-8.16-11.496-11.496.057-9.742 1.667-26.722-9.076-19.665-20.385 13.392-13.009 55.968-6.656 70.187",
    style: {
      fill: "url(#k)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      display: "inline"
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.933 920.723c8.981 6.786 16.92 12.785 22.554 15.967 54.941 2.778 68.66-27.594 69.658-52.493-4.89.224-13.223-.973-17.714-7.74-11.214 3.68-45.166 14.003-45.757 16.322-3.065 12.036-12.175 21.756-28.741 27.944",
    style: {
      fill: "url(#l)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      display: "inline"
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.275 910.581c33.185-24.7 28.914-74.159 29.45-76.691 1.363-6.439-6.65-28.252-16.274-24.25-16.024 6.664 11.277 44.445 7.614 65.166-.763 4.32-13.99 7.503-22.98 8.899-1.037.16-.116 14.095-4.627 20.51-.645.917 6.21 6.818 6.817 6.366",
    style: {
      fill: "url(#m)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      display: "inline"
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.904 907.191c42.492-41.749 20.982-116.278 6.146-94.51 20.377-4.12 23.618 64.267-6.146 94.51",
    style: {
      fill: "url(#n)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.217 907.776c.786-1.06-13.881-6.083-22.746-14.065-.983-.885-1.142 12.912-2.07 18.665-.578 3.575 5.492 7.174 6.88 7.622 1.15.372 14.71-7.869 17.936-12.222",
    style: {
      fill: "url(#o)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      display: "inline"
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.585 868.013c-5.099-25.843 4.18-41.04 41.358-46.378.18.57 41.32-13.256 55.792-13.35-3.923 6.234.043 21.624 4.81 34.277 0 0-34.828 9.087-101.96 25.451",
    style: {
      fill: "url(#p)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.655 863.894c4.412-1.58 17.008-5.39 32.055-.152 10.305 3.588 16.22 12.633 20.668 16.112 10.479 8.195 29.823-.908 33.321-.853 1.438.022-25.966-24.602-46.628-25.848-27.775-1.675-45.111 12.782-39.416 10.74",
    style: {
      fill: "url(#q)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      display: "inline"
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.427 741.435c-.153 8.404-2.797 28.464-11.307 42.173-3.893 6.27 14.52-8.277 16.502-20.78 1.09-6.878-5.069-28.09-5.195-21.393",
    style: {
      fill: "url(#r)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.79 833.107c9.24-4.718 17.657-10.922 22.992-22.443.903-1.95-4.4-.058-8.476-5.844-4.035-5.729-3.083-11.543-6.54-11.078-10.8 1.453-25.2 11.638-25.2 11.638s.828 11.144 3.747 15.673c6.019 9.34 13.478 12.054 13.478 12.054",
    style: {
      fill: "url(#s)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      display: "inline"
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.092 803.781c2.725 9.889 17.873 8.097 14.706-11.152-1.365 1.996-4.776 12.957-14.706 11.152",
    style: {
      opacity: 0.55223843,
      fill: "url(#t)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.485 832.283c-5.1-3.469-9.504-7.784-12.325-12.35s-4.06-27.847.687-33.633c2.608-6.364 11.841-12.515 22.097-15.231-19.495 22.605-13.178 56.867 4.074 53.535.862-.166-12.826 7.73-14.533 7.679",
    style: {
      fill: "url(#u)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.322 893.03c3.81 2.818 20.24 15.535 23.86 13.522-8.41 20.56-30.553 3.143-23.86-13.523",
    style: {
      fill: "url(#v)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.057 777.56c-3.947 2.301-8.693 4.874-9.635 7.2-3.162 6.644-4.347 18.566-3.385 17.882 9.384-6.673 20.25-8.523 24.203-12.097 11.714-10.59 16.262-32.484 13.8-29.238-7.968 10.505-20.91 13.88-24.983 16.254M78.65 924.573s-11.081-7.664-10.877-10.123c1.697-20.433-1.93-21.625-3.757-21.408-2.208.262-13.682 7.505-15.92 27.958-1.625 14.842 4.24 38.03 5.133 39.284 4.623-12.423 2.82-22.423 25.42-35.71m121.058-90.522c-.552-15.318-9.774-25.85-16.038-23.383-2.657 1.046-4.441 8.179-3.508 12.601.827 3.923 6.466 19.102 6.872 20.385.958 3.034 7.43 21.63 6.28 30.565-1.009 7.831-23.71 10.54-23.71 10.54s-.381 6.375-1.164 10.683c-.962 5.295-2.87 9.45-2.87 9.45s4.943 4.604 5.143 4.6c.2-.006 31.109-16.714 28.995-75.44M176.01 881.5c1.598-.447 11.032-2.942 10.526-3.274-3.5-2.296-7.485-5.187-14.157-10.377-37.046-28.812-70.695-4.545-70.032-4.765 6.152-2.046 12.648-3.202 21.672-2.6 7.27.486 18.697 4.17 28.706 16.103 3.724 4.438 7.948 7.45 23.285 4.913m-16.525-62.54c1.12-.97 5.017-8.314 4.315-8.485-9.83-2.39-10.788-6.74-11.75-11.472-.902-4.433-.762-5.065-2.625-4.45-15.047 4.97-19.209 7.701-21.511 9.612-3.607 2.993-1.077 11.037.333 14.233 1.966 4.456 9.192 12.518 12.554 13.167 4.904.947 16.494-9.1 18.684-12.606m10.936-27.142c-.815-3.335-3.435-7.63-4.133-7.63-.658 0-7.62 5.386-9.417 7.263-4.081 4.26-2.092 11.98 2.435 14.627 7.662 4.481 13.288-5.371 11.115-14.26m-5.777-12.756c3.352-3.349 7.808-8.845 8.993-17.198.465-3.274.735-6.154-1.302-12.627-.472-1.5-1.906-5.815-1.96-5.246-1.059 11.223-2.61 23.686-9.936 36.931-2.3 4.158-1.063 3.402 4.205-1.86m-78.62 66.848c-3.993 16.751 6.59 38.75 15.163 40.005 8.287 1.212 32.045-5.961 44.505-9.426 3.264-.908 5.02-.434-2.201-6.485-11.323-7.697-20.461-8.688-29.578-7.654-10.056 1.142-17.591 4.118-16.886 3.528 4.61-3.86 12.822-10.764 28.688-13.89 6.896-1.359 17.538-1.478 30.386 3.54 15.937 6.224 24.238 15.455 30.975 18.584 2.4 1.114 3.257.596 4.205-2.189 1.588-4.664-8.067-33.789-11.565-42.282-5.338-12.96.89-19.155-.47-18.855-6.604 1.455-12.426 5.699-17.307 10.069-11.93 10.682-19.203 12.957-20.282 12.866-3.407-.29-9.782-6.32-12.099-9.383-1.477-1.954-27.929 3.152-35.73 9.929-.178.155-6.196 4.015-7.803 11.643M77.55 918.84c8.724-3.66 17.266-11.44 16.527-11.568-4.53-.788-21.234-12.234-21.222-12.115.573 5.907-.714 11.215-1.301 17.07-.245 2.44 3.01 6.224 5.996 6.613m28.152-25.605c-1.67 3.72-3.412 18.351-27.53 27.74-.7.272 20.211 14.57 21.35 14.62 69.054 3.032 68.468-49.554 67.552-50.88-.133-.192-6.039.014-10.614-2.157-.349-.165-3.452-1.765-5.302-4.174-.627-.817-.725-1.261-3.05-.586-10.763 3.128-42.896 14.657-42.406 15.437m-21.513-25.65c-12.33-43.086 30.944-45.085 37.805-46.744 5.306-1.283 4.15-1.782 3.03-6.8-1.57-7.046-1.08-13.188.266-19.772 1.273-6.226 1.93-9.374 4.62-12.496 2.168-2.516 14.384-8.27 17.412-9.723 12.905-6.19 17.836-12.993 19.274-18.344 1.014-3.773 2.498-13.071 1.831-19.718-.164-1.636.891.928 6.142 17.242 2.683 8.336 1.362 18.345-7.1 27.382-1.15 1.227-.592 1.47.954 4.023 3.21 5.306 4.985 11.94 4.485 16.767-.41 3.954-2.1 7.693.318 7.403.35-.042 11.028-1.659 18.338 2.987 4.95 3.147 12.003 9.179 10.172 34.374-4.008 55.172-30.965 67.179-31.154 67.185-.456.016-5.5-5.22-5.798-4.604-15.456 31.931-47.35 30.784-65.138 31.12-3.556.067-18.344-12.385-19.59-11.533-15.744 10.759-20.114 13.446-26.184 40.944-.233-.436-8.418-14.956-8.079-44.157.279-23.925 13.35-35.216 19.16-34.565 7.054.79 10.595 4.47 20.53 10.998 1.773 1.165 8.038 4.954 9.464 4.92 3.552-.085 5.975-6.61 6.555-10.836.585-4.261 1.15-3.231-2.176-4.376-4.193-1.443-11.426-9.296-15.137-21.676",
    style: {
      fill: "#2c3b54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.113 892.834c6.476-3.533 43.234-15.025 43.564-15.746.24-.527-43.116 17.308-52.936 10.697-.592-.398 2.294 1.721 4.902 2.257.184.037.171 6.892-2.3 10.77-.693 1.088 5.267-7.157 6.77-7.978",
    style: {
      fill: "url(#w)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.008 784.186c-4.03 2.813-9.585 6.743-10.721 9.774-.67 1.787-1.123-4.992 3.452-9.03 2.577-2.276 8.093-1.319 7.269-.744",
    style: {
      fill: "url(#x)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      display: "inline"
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.59 806.828c4.57 1.363 8.1-1.428 10.035-7.442.228-.71-.566 5.267-3.406 7.489-2.708 2.118-7.593-.334-6.63-.047",
    style: {
      fill: "url(#y)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      display: "inline"
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.19 813.036c6.475-3.533 13.104-2.992 18.755-2.738 3.751.17-7.066-4.205-19.354-3.521-1.313 1.117-5.213 7.636-10.71 14.237-.825.99 9.805-7.157 11.308-7.978",
    style: {
      fill: "url(#z)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      display: "inline"
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.559 827.011c3.802-.783 8.57-2.075 11.727-2.393 2.631-.265 5.929-1.747 8.462.978-1.41-1.934-4.108-5.84-4.948-8.397.765 3.005-2.655 3.43-3.505 3.564-19.118 3.02-30.618 8.169-36.42 17.742 10.99-8.502 23.966-11.346 24.684-11.494",
    style: {
      fill: "url(#A)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      display: "inline"
    },
    transform: "translate(-152.932 -3059.705)scale(4.20707)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJitsiLogo);
export default __webpack_public_path__ + "static/media/jitsi-logo.326fd4020406649b8b02c8d68155c349.svg";
export { ForwardRef as ReactComponent };